import { useEffect, useState } from 'react';
import { useIntersectionObserver } from './useIntersectionObserver';

export const useIsIntersecting = ({
  root = null,
  rootMargin = '0px',
  threshold = 0,
}: IntersectionObserverInit = {}): {
  setNode: (instance: HTMLElement | null) => void;
  isIntersecting: boolean;
} => {
  const { entry, observer } = useIntersectionObserver({ root, rootMargin, threshold });
  const [node, setNode] = useState<HTMLElement | null>(null);

  useEffect(() => {
    if (!observer) {
      return () => null;
    }
    observer.disconnect();
    if (node) observer.observe(node);
    return () => observer.disconnect();
  }, [node, observer]);

  return { setNode, isIntersecting: Boolean(entry?.isIntersecting) };
};
